module.exports = require("qs");


//////////////////
// WEBPACK FOOTER
// external "qs"
// module id = 66
// module chunks = 0